import { color, media, typography } from '@gyym/ui'
import styled from 'styled-components'

export const Container = styled.span`
  ${typography('caption1')}
  text-align: center;
  width: 100%;
  margin: 0 auto;
  position: relative;
  display: block;

  ${media.pc} {
    max-width: 382px;
  }

  &::before {
    content: '';
    background: ${color('gray.05')};
    position: absolute;
    height: 1px;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
    z-index: -2;
    left: 0;
  }

  &::after {
    content: '';
    background: ${color('white')};
    position: absolute;
    height: 100%;
    width: 78px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: -1;
  }
`
